import {Route, Switch, useRouteMatch} from "react-router-dom";


import Dashboard from "./dashboard";


import SaveHazards from "./saveHazards/saveHazards";

const  Administration = () => {
  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let { path } = useRouteMatch();

  return (
  <div>
    <Switch>
      <Route exact path={path}>
        <Dashboard/>
      </Route>
      <Route path={`${path}/saveHazards`}>
        <SaveHazards />
      </Route>
    </Switch>
  </div>
  );
}

export default Administration;